var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loader'),_c('Alert'),_c('Confirm'),(!_vm.isLoading)?_c('layout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }